import './style.scss';

/** The shared Swiper vendor is loaded only when this block appears. */
export function project_details(root = document) {
  const vendor = window.fbsThemeVendors || {};
  const Swiper = vendor.Swiper;
  const mods = vendor.SwiperModules || {};
  if (!Swiper || !mods.Navigation || !mods.Pagination || !mods.Keyboard || !mods.A11y) return;

  root.querySelectorAll('[data-project-gallery]').forEach((gallery) => {
    if (gallery.swiperInstance) return;
    const slidesElement = gallery.querySelector('.project-details__slides');
    const slides = Array.from(gallery.querySelectorAll('[data-project-slide]'));
    const controls = gallery.querySelector('[data-project-controls]');
    if (!slidesElement || slides.length < 2 || !controls) return;
    const previous = controls.querySelector('[data-project-previous]');
    const next = controls.querySelector('[data-project-next]');
    const pagination = controls.querySelector('[data-project-pagination]');
    if (!previous || !next || !pagination) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';
    slides.forEach((slide) => wrapper.appendChild(slide));
    slidesElement.appendChild(wrapper);

    const status = gallery.querySelector('[data-project-status]');
    const swiper = new Swiper(slidesElement, {
      modules: [mods.Navigation, mods.Pagination, mods.Keyboard, mods.A11y],
      slidesPerView: 1,
      spaceBetween: 0,
      speed: reducedMotion.matches ? 0 : 500,
      grabCursor: true,
      simulateTouch: true,
      allowTouchMove: true,
      loop: false,
      rewind: false,
      watchOverflow: true,
      keyboard: { enabled: true, onlyInViewport: true },
      a11y: { enabled: true },
      navigation: { prevEl: previous, nextEl: next },
      pagination: {
        el: pagination,
        clickable: true,
        bulletClass: 'project-details__dot',
        bulletActiveClass: 'project-details__dot--active',
        renderBullet(index, className) {
          return '<button type="button" class="' + className + '" aria-label="Show project image ' + (index + 1) + '"><span aria-hidden="true"></span></button>';
        },
      },
      on: {
        init(instance) {
          gallery.dataset.projectGalleryReady = 'true';
          if (status) status.textContent = 'Image 1 of ' + instance.slides.length;
        },
        slideChange(instance) {
          if (status) status.textContent = 'Image ' + (instance.realIndex + 1) + ' of ' + instance.slides.length;
          pagination.querySelectorAll('button').forEach((dot, index) => dot.setAttribute('aria-current', String(index === instance.realIndex)));
        },
      },
    });
    gallery.swiperInstance = swiper;
    const updateSpeed = () => { swiper.params.speed = reducedMotion.matches ? 0 : 500; };
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', updateSpeed);
    else if (reducedMotion.addListener) reducedMotion.addListener(updateSpeed);
  });
}
